import React, {PureComponent} from "react"
import ReactDOM from "react-dom";
import Events from "../../events/events";
import Modal from "../modal/Modal";
import {dispatchEvent} from "helpers/analytics/AnalyticsEventDispatcher";
import { showIfSizeSelectionHasErrors } from '../size-selection-errors';
import {
  isMobile,
  isIOS,
  isAndroid
} from "react-device-detect";

export class ShareModal extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      setModalIsOpen: false,
    };
    this.handleShareButtonClick = this.handleShareButtonClick.bind(this);
    this.analyticsDispatchEvent = this.analyticsDispatchEvent.bind(this);
    this.buildShareUrl = this.buildShareUrl.bind(this);
  }

  componentDidMount(){
    const shareButton = document.querySelector('#shareButton');
    if(shareButton) {
      shareButton.addEventListener("click",()=> this.handleShareButtonClick());
    }
  }

  analyticsDispatchEvent(type) {
    dispatchEvent("dataStateChange", {
      action : "sharePDP",
      type,
      lastAction : type === "openModal" ? "false" : "true",
      device : isMobile ? isIOS ? "ios" : isAndroid ? "android" : "other" : "desktop"
    });
  }

  buildShareUrl (url, trackingId, encode) {
    const shareUrl = url.includes("?") ? url + "&s_share=" + trackingId : url + "?s_share=" + trackingId;
    return encode ? encodeURIComponent (shareUrl) : shareUrl;
  }

  handleShareButtonClick() {
    const sizeSelected = document.querySelector('input[name="sizeNotSelected"]');
    if(sizeSelected) {
      showIfSizeSelectionHasErrors()
      return;
    }
    const {skuTitle, canonicalUrl, defaultImage, rootElement} = this.props;
    const encodedSkuTitle = encodeURIComponent(skuTitle)
    this.analyticsDispatchEvent("openModal");
    if (
      isMobile && typeof window !== "undefined" &&
      window.navigator &&
      window.navigator.share
    ) {
      const trackingId = isIOS ? "w_ios" : isAndroid ? "w_dro" : "w_oth";
      navigator.share({
        title: skuTitle,
        url: this.buildShareUrl(canonicalUrl, trackingId, false)
      }).then();
    } else {
      document.body.classList.add("no-scroll");
      const modalProps = {
        active: true,
        focusTrapOptions : {
          clickOutsideDeactivates: true,
          returnFocusOnDeactivate: true,
          escapeDeactivates: true,
        },
        component: "Share modal",
      };

      const closeModal = (event) => {
        event && event.stopPropagation();
        Events.modalWillClose.trigger(document);
        ReactDOM.unmountComponentAtNode(rootElement);
        document.body.classList.remove("no-scroll");
      }

      const copyToClipboard = () => {
        this.analyticsDispatchEvent("copyLink");
        const urlInput = document.querySelector(".inline-form__input");
        const button = document.querySelector(".inline-form__copy-button");
        if (urlInput) {
          urlInput.select();
          document.execCommand("copy")
        }
        button.classList.add("inline-form__copied");
        button.innerHTML = "Copied to clipboard";
      }

      const ShareButton = ({url, type, imageClass}) => {
        return (
          <a
            target="_blank"
            href={url}
            className="share-links__item"
            onClick={() => { this.analyticsDispatchEvent(type) }}
          >
            <div className={`image-icon ${imageClass}`}/>
          </a>
        )
      }

      ReactDOM.render(
        <Modal
          onClose={event => closeModal(event)}
          {...modalProps}
        >
          <div className="share-modal">
            <header className="header"><h2 className="headerTitle">Share</h2></header>
            <div className="content">
              <div className="inline-form">
                <input className="inline-form__input"
                  id="url"
                  name="url"
                  value={this.buildShareUrl(canonicalUrl, "w_cop", false)}
                />
                <button type="button" className="button inline-form__copy-button" onClick={copyToClipboard}>
                  Copy link
                </button>
              </div>
              <p>
                You can copy this link into emails, text messages or post it on social
                media.
              </p>
              <p className="heading">Share now</p>
              <div className="share-links">
                <ShareButton
                  url={`https://wa.me/?text=${encodedSkuTitle + " " + this.buildShareUrl(canonicalUrl, 'w_wha', true)}`}
                  type={'Whatsapp'}
                  imageClass={'image-icon-whatsapp'}
                />
                <ShareButton
                  url={`https://twitter.com/intent/tweet?url=${this.buildShareUrl(canonicalUrl, 'w_twi', true)}&text=${encodedSkuTitle}`}
                  type={'Twitter'}
                  imageClass={'image-icon-twitter'}
                />
                <ShareButton
                  url={`https://www.facebook.com/sharer/sharer.php?u=${this.buildShareUrl(canonicalUrl, 'w_fac', true)}`}
                  type={'Facebook'}
                  imageClass={'image-icon-facebook'}
                />
                <ShareButton
                  url={`https://www.pinterest.com/pin/create/button/?url=${this.buildShareUrl(canonicalUrl, 'w_pin', true)}&media=${defaultImage}&description=${encodedSkuTitle}`}
                  type={'Pinterest'}
                  imageClass={'image-icon-pinterest'}
                />
              </div>
              <div>
              </div>
            </div>
          </div>
        </Modal>,
        rootElement
      )
    }
  }
  render() {
    return (
      <React.Fragment/>
    );
  }
}
